var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCampaignOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.6H13.2C13.6418 1.6 14 1.24183 14 0.8C14 0.358172 13.6418 0 13.2 0H3C1.34315 0 0 1.34315 0 3V19C0 20.6569 1.34315 22 3 22H19C20.6569 22 22 20.6569 22 19V9.8C22 9.35817 21.6418 9 21.2 9C20.7582 9 20.4 9.35817 20.4 9.8V19C20.4 19.7732 19.7732 20.4 19 20.4H3C2.2268 20.4 1.6 19.7732 1.6 19V3C1.6 2.2268 2.2268 1.6 3 1.6Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.6H15.8C15.3582 1.6 15 1.24183 15 0.8C15 0.358172 15.3582 0 15.8 0H19C20.6569 0 22 1.34315 22 3V4.2C22 4.64183 21.6418 5 21.2 5C20.7582 5 20.4 4.64183 20.4 4.2V3C20.4 2.2268 19.7732 1.6 19 1.6Z",
    fill: "var(--primary-6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 6.8V7.2C20.4 7.64183 20.7582 8 21.2 8C21.6418 8 22 7.64183 22 7.2V6.8C22 6.35817 21.6418 6 21.2 6C20.7582 6 20.4 6.35817 20.4 6.8Z",
    fill: "var(--primary-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13C4 12.4477 4.44772 12 5 12H9C9.55228 12 10 12.4477 10 13V17C10 17.5523 9.55228 18 9 18H5C4.44772 18 4 17.5523 4 17V13ZM5.6 16.4V13.6H8.4V16.4H5.6Z",
    fill: "var(--primary-6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C12.4477 4 12 4.44772 12 5V9C12 9.55228 12.4477 10 13 10H17C17.5523 10 18 9.55228 18 9V5C18 4.44772 17.5523 4 17 4H13ZM13.6 5.6V8.4H16.4V5.6H13.6Z",
    fill: "var(--primary-6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12 12.4477 12.4477 12 13 12H17C17.5523 12 18 12.4477 18 13V17C18 17.5523 17.5523 18 17 18H13C12.4477 18 12 17.5523 12 17V13ZM13.6 16.4V13.6H16.4V16.4H13.6Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignOutlined);
export default __webpack_public_path__ + "static/media/campaignOutlined.e985fdd3c994b3983d44f29353ed0923.svg";
export { ForwardRef as ReactComponent };